import React, { HTMLProps } from "react";
import styles from "./Content.module.css";

export default React.forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(
  (props, ref) => {
    return <div ref={ref} className={styles.wrapper} {...props} />;
  }
);
